import {
  SanityOrMagentoProductImage,
  SanityProductImageSelection,
} from '../../../lib/products/images'
import { isNotNull } from '../../../utils/collectionTools'
import { imageUrlFor } from '../../../utils/image-url'
import { ItemImageSourceFactory } from '../details/images/ItemImage'
import { ItemImagePreviewSourceFactory } from '../details/images/ItemImagePreviews'

function isSanityProductImage(
  image: SanityOrMagentoProductImage,
): image is SanityProductImageSelection {
  return 'asset' in image && image.asset !== undefined
}

// image sizes differ in modal
export const modalImageSourceFactory: ItemImageSourceFactory = (image) => {
  if (!isSanityProductImage(image)) {
    return {
      source: { _tag: 'SingleSource' as const, src: image.url },
      srcZoom: image.url,
      altText: image.label || '',
    }
  }

  const imageUrlForWidth = (width: number) =>
    imageUrlFor(image.asset).width(width).auto('format').url()

  const defaultSrc = imageUrlForWidth(800) ?? ''
  const srcSet = [
    `${imageUrlForWidth(400)} 400w`,
    `${imageUrlForWidth(600)} 600w`,
    `${imageUrlForWidth(800)} 800w`,
    `${imageUrlForWidth(1000)} 1000w`,
    `${imageUrlForWidth(1400)} 1400w`,
    `${imageUrlForWidth(1600)} 1600w`,
  ].join(', ')
  const sizes = ['(max-width: 599px) 82vw', '(max-width: 1055px) 29vw', '267px'].join(', ')
  return {
    source: { _tag: 'SourceSet' as const, defaultSrc, srcSet, sizes },
    srcZoom: imageUrlForWidth(2000) ?? '',
    altText: image.alt || '',
  }
}

// preview images are slightly larger in modal
export const modalImagePreviewSourceFactory: ItemImagePreviewSourceFactory = (image) => {
  if (!isSanityProductImage(image)) {
    return { alt: image.label ?? '', key: image.url, src: image.url, srcSet: '' }
  }

  const partial = imageUrlFor(image.asset).width(63).auto('format')
  const src1x = partial.url()
  const src2x = partial.dpr(2).url()
  const src3x = partial.dpr(3).url()
  const srcSet = [src1x, src2x ? `${src2x} 2x` : null, src3x ? `${src3x} 3x` : null]
    .filter(isNotNull)
    .join(', ')

  return { alt: image.alt ?? '', key: image.asset._id, src: src1x ?? '', srcSet }
}
